import contextBasedEnvironments from "./contextBasedEnvironments";

export default () =>
	[
		{include: 'local', target: contextBasedEnvironments.LOCAL},
		{include: 'localhost', target: contextBasedEnvironments.LOCAL},
		{include: '.dev.', target: contextBasedEnvironments.DEV},
		{include: '.at.', target: contextBasedEnvironments.AT},

		// default
		{include: '', target: contextBasedEnvironments.PROD}
	]
		.filter(environment => document.location.hostname.includes(environment.include))
		.shift()
		.target;
